// extracted by mini-css-extract-plugin
export default {"Layout":"TestLayout_Layout__ABn2G","Products":"TestLayout_Products__2rNoD"};